// eslint-disable-next-line @trello/export-matches-filename
import { Noun, Verb, trackUe } from '@trello/analytics';

const trackAnalytics = (verb: Verb, noun: Noun, method: string, context: object) => {
  trackUe({
    category: Noun.ATLASSIAN_ACCOUNT_ONBOARDING,
    verb: verb,
    directObj: noun,
    method: method,
    context: JSON.stringify(context),
  });
}

export const track = trackAnalytics;